export const SERVICE_CATEGORY_KEYS = [
    'category_registered_helper',
    'category_electrician',
    'category_plumber',
    'category_carpenter',
    'category_technician',
    'category_housekeeping',
    'category_security',
    'category_chairman',
    'category_admin',
    'category_manager',
    'category_emergency',
    'category_other',
]

export const getServiceCategoryOptions = (t) => SERVICE_CATEGORY_KEYS.map((key) => ({
    value: t(`findService.${key}`),
    label: t(`findService.${key}`),
}))